/**
 * @file navigation.js
 */
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.kodakNavigation = {
    attach: function (context, settings) {
      // Ensure that the behavior is only applied once using the 'region-header' identifier
      once('region-header', '.region-header', context).forEach(function () {

        $('.thirdlevelbutton').on('click', function(event) {
          // Prevent event propagation
          event.stopPropagation();

          $(this).toggleClass('opened');
          $(this).toggleClass('closed');

          // Get the href attribute value (ID) and target the element
          let targetID = $(this).attr('href');

          // Toggle 'opened' class on the target element
          $(targetID).toggleClass('opened');

          // Toggle 'hidden' class on the target element
          $(targetID).toggleClass('hidden');

          // Optional: Prevent default behavior of anchor tag
          event.preventDefault();
        });

        function navigationLock() {
          if($('.navbar-toggler').hasClass('collapsed')) {
            $('html, body').removeClass('screen-lock');
          }
          else {
            $('html, body').addClass('screen-lock');
          }
        }

        $('.navbar-toggler').click(function () {
          navigationLock();
        });

        // Find the active language link.
        let activeLanguage = $('.language-switcher-language-url .dropdown-menu .is-active', context).text().trim();

        // Replace "Language" with the active language text.
        if (activeLanguage) {
          $('#languageDropdown', context).text(activeLanguage);
        }

        let contactLink = $('#block-kodak-utilitynavigation .nav-link:contains("Contact")', context);

        // If the link is found, grab its href attribute
        if (contactLink.length) {
          let contactUrl = contactLink.attr('href');

          // Apply the URL to elements with the class 'mobile-contact-us'
          $('.mobile-contact-us', context).attr('href', contactUrl);
        }

        // Handling Window Resizing Events
        let previousWindowWidth = window.innerWidth;
        window.addEventListener('resize', function() {

          if(window.innerWidth !== previousWindowWidth) {

            // Reset Mobile Menu & Remove Screen Lock
            if(window.innerWidth > 1100 ) {
              $('html, body').removeClass('screen-lock');
              $('.navbar-toggler').addClass('collapsed');
              $('#navbar-wrapper').removeClass('show');
            }
            else {
              navigationLock();
            }
            previousWindowWidth = window.innerWidth;
          }
        });

      });
    }
  };
})(jQuery, Drupal, once);
